import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PrintButton from "../../components/PrintButton";
import "./styles.sass";

export default function Page() {
  const { i18n } = useTranslation();
  const isRtl = i18n.language === "he"; // Check if the current language is Hebrew (RTL)

  return (
    <main className="main" style={{ direction: isRtl ? "rtl" : "ltr" }}>
      <h1 className="h1">{i18n.t("Page.title")}</h1>

      <p className="pFirst">{i18n.t("Page.description1")}</p>

      <h2 className="h2 h2Main">{i18n.t("Page.new_series")}</h2>

      <p className="pSecond">{i18n.t("Page.description2")}</p>

      <p className="pSecond">{i18n.t("Page.description3")}</p>

      <p className="pSecond">{i18n.t("Page.description4")}</p>

      <ul className="list">
        <li className="listItem">
          <RouterLink to="/family/stocks">
            <h3 className="listTitle">{i18n.t("Page.stocks_indices")}</h3>
          </RouterLink>
        </li>
        <ul className={isRtl ? "listSub" : "listSubLtr"}> 
          <RouterLink to="/family/stocks/1" className="listSubLink">
            <li className="listSubItem">{i18n.t("Page.foreign_stocks")}</li>
          </RouterLink>
          <RouterLink to="/family/stocks/2" className="listSubLink">
            <li className="listSubItem">{i18n.t("Page.israel_stocks")}</li>
          </RouterLink>
          <RouterLink to="/family/stocks/3" className="listSubLink">
            <li className="listSubItem">{i18n.t("Page.global_indices")}</li>
          </RouterLink>
        </ul>
        <RouterLink to="/family/bonds">
          <li className="listItem">
            <h3 className="listTitle">{i18n.t("Page.bonds_indices")}</h3>
          </li>
        </RouterLink>
        <ul className={isRtl ? "listSub" : "listSubLtr"}> 
          <RouterLink to="/family/bonds/1" className="listSubLink">
            <li>{i18n.t("Page.government")}</li>
          </RouterLink>
          <RouterLink to="/family/bonds/2" className="listSubLink">
            <li>{i18n.t("Page.corporate")}</li>
          </RouterLink>
        </ul>
        <RouterLink to="/family/ai">
          <li className="listItem">
            <h3 className="listTitle">{i18n.t("Page.ai_indices")}</h3>
          </li>
        </RouterLink>
        <ul className={isRtl ? "listSub" : "listSubLtr"}> 
          <RouterLink to="/family/ai/1" className="listSubLink">
            <li>{i18n.t("Page.ai_stocks")}</li>
          </RouterLink>
          <RouterLink to="/family/ai/2" className="listSubLink">
            <li>{i18n.t("Page.ai_bonds")}</li>
          </RouterLink>
        </ul>
      </ul>
      <PrintButton />
    </main>
  );
}
